import { createSelector } from 'reselect';
import get from 'lodash/get';

export const getInsOutsReportPagination = (state) => get(state, 'reports.ins_outs.pagination', {});

export const getInsOutsReportFilters = (state) => get(state, 'reports.ins_outs.filters', {});

export const getInsOutsReportNeedFetch = (state) => get(state, 'reports.ins_outs.needFetch', false);

export const getInsOutsReportIsLoading = (state) => get(state, 'reports.ins_outs.isLoading', false);

export const getInsOutsReportRecords = (state) =>
  get(state, 'reports.ins_outs.entities.assets', {});
export const getInsOutsReportRecordsIds = (state) =>
  get(state, 'reports.ins_outs.result.assets', []);

export const getInsOutsReportVisibleRecords = createSelector(
  [getInsOutsReportRecordsIds, getInsOutsReportRecords],
  (ids, assets) => ids.map((id) => assets[id])
);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/selectors/ins_outs_report_selectors.js